import * as React from 'react';
import { connect } from 'react-redux';

import { CheckboxField } from '@cian/components';

import { ButtonCheckbox } from '../../../../common/components/button_checkbox';
import { IAppState, Dispatch } from '../../../../common/state';
import { ESaleType } from '../../../../json_query';
import { FOfferType } from '../../../../utils/category';
import { changeMortgageCheckbox, changeSaleTypes } from '../../../state/advanced/sale_type';
import { InlineParam, Row } from '../markup';

interface ISaleTypesProps {
  offerType: FOfferType;

  saleTypes: ESaleType[] | undefined;
  onSaleTypeChanged(saleType: ESaleType, value: boolean): void;

  mortgage: boolean;
  onChangedMortgage(value: boolean): void;
}

const saleTypes: React.StatelessComponent<ISaleTypesProps> = props => {
  const offerSaleTypes: Array<{ name: string; type: ESaleType }> =
    props.offerType === FOfferType.FlatNew
      ? [
          { name: '214-Ф3', type: ESaleType.F3 },
          { name: 'Договор ЖСК', type: ESaleType.GSKContract },
          { name: 'Переуступка', type: ESaleType.Reassignment },
        ]
      : [
          { name: 'Свободная', type: ESaleType.Free },
          { name: 'Альтернативная', type: ESaleType.Alternative },
        ];

  return (
    <Row title="Тип продажи">
      {offerSaleTypes.map((saleTypesProps, i) => (
        <InlineParam key={i.toString()}>
          <ButtonCheckbox
            value={isSaleTypeExists(props.saleTypes, saleTypesProps.type)}
            onValueChange={value => props.onSaleTypeChanged(saleTypesProps.type, value)}
          >
            {saleTypesProps.name}
          </ButtonCheckbox>
        </InlineParam>
      ))}
      <InlineParam>
        <CheckboxField
          label={`Возможна ипотека`}
          value={props.mortgage}
          onValueChange={value => props.onChangedMortgage(value)}
        />
      </InlineParam>
    </Row>
  );
};

// tslint:disable-next-line:no-default-export
export default connect(
  (state: IAppState) => ({
    saleTypes: (state.filters.jsonQuery.sost_type && state.filters.jsonQuery.sost_type.value) || undefined,
    mortgage: (state.filters.jsonQuery.ipoteka && state.filters.jsonQuery.ipoteka.value) || false,
  }),
  (dispatch: Dispatch) => ({
    onSaleTypeChanged: (saleType: ESaleType, value: boolean) => {
      dispatch(changeSaleTypes(saleType, value));
    },
    onChangedMortgage: (value: boolean) => {
      dispatch(changeMortgageCheckbox(value));
    },
  }),
  (stateProps, dispatchProps, ownProps: { offerType: FOfferType }) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
  }),
)(saleTypes);

function isSaleTypeExists(existingSaleTypes: ESaleType[] | undefined, saleType: ESaleType): boolean {
  return !!existingSaleTypes && existingSaleTypes.indexOf(saleType) > -1;
}
